// extracted by mini-css-extract-plugin
export default {"menu-color":"hsla(0, 0%, 100%, 0.95)","menu-color-active":"hsla(0, 0%, 100%, 0.95)","menu-background":"#282c34","column-second-menu-background":"#fff","vab-border-radius":"2.5px"};